import { createAction, props } from '@ngrx/store';
import { CommissionTableRequest } from '../../../models/commission-table/commission_table_request';

export const setCommissions = createAction(
  '[Commissions] setCommissions',
  props<{ commissions: CommissionTableRequest[] }>()
);
